import React, { useState } from "react";
import Searchbar from "components/Searchbar";
import fetchEmployeesOnly from "layouts/pages/employees/actions/fetchEmployeesOnly";
import PictureAvatar from "components/PictureAvatar";
import { sortByLastFirstName } from "utils/sortFunctions";
import { useAppContextController } from "context/AppContext";
import { getApplicantJobStatus } from "utils/helpers/applicant";
import JobStatusButton from "components/JobStatusButton";
import { useQueryClient } from "react-query";

const EmployeeSearchBar = ({ dropRight = true }) => {
  const { currentJob } = useAppContextController();
  const [searchRefetchKey, setSearchRefetchKey] = useState(0);
  const queryClient = useQueryClient();

  const refetchSearch = () => setSearchRefetchKey(Math.random());
  // Custom columns for employee searchbar
  const employeeSearchColumns = [
    {
      title: "Avatar",
      field: "profileImg",
      width: 50,
      customCell: (image, row) => (
        <PictureAvatar
          image={row?.profileImg}
          firstName={row?.firstName}
          lastName={row?.lastName}
          userId={row?._id}
          size="md"
        />
      ),
    },
    { title: "First Name", field: "firstName", width: 130 },
    { title: "Last Name", field: "lastName", width: 130 },
    { title: "Email", field: "email", width: 180 },
    {
      title: "SSN-4",
      field: "socialSecurity",
      width: 80,
      customCell: (ssn) => {
        if (!ssn) return "";
        const numString = ssn.toString();
        const last4Digits = numString.slice(-4);
        return last4Digits;
      },
    },
    { title: "Helm ID", field: "employeeID", width: 80 },
    {
      title: "Current Job",
      field: "slug",
      width: 80,
      customCell: (_id, row) => {
        const applicantJobStatus = getApplicantJobStatus(row, currentJob.jobSlug);
        return (
          <JobStatusButton
            status={applicantJobStatus}
            job={currentJob}
            applicant={row}
            refresh={() => {
              queryClient.invalidateQueries("shiftJobAllStaffingPool");
              refetchSearch();
            }}
          />
        );
      },
    },
  ];

  return (
    <Searchbar
      fetch={fetchEmployeesOnly}
      fetchAll={false}
      placeholder="Add Employees"
      columns={employeeSearchColumns}
      queryCharacterLimit={3}
      resultsLimit={15}
      filters={{ status: "Employee" }}
      searchBy={["firstName", "lastName", "email", "altEmail", "employeeID"]}
      filterBy="_id"
      scrollLimit={200}
      sortFunction={sortByLastFirstName}
      onRowClick={() => {}}
      returnAfterClick
      autoCenter
      dropRight={dropRight}
      refetchDependency={searchRefetchKey}
    />
  );
};

export default EmployeeSearchBar;
